export default "__VITE_ASSET__DDGyBLlE__"